Wee.fn.make('autocompleteJobs', {
  init: function () {
    this.autocompleteJobs();
  },
  unload: function () {
    this.unload();
  },
  autocompleteJobs: function () {
    var jobInput = document.getElementById('jobSearch');

    var currentFocus;

    var jobListing = JSON.parse(document.getElementById('jobList').value);

    // Fire when user adds text to input
    jobInput.addEventListener('input', function (event) {
      var container,
        element,
        counter,
        val = this.value;

      closeAllLists();
      if (!val) {
        return false;
      }
      currentFocus = -1;
      container = document.createElement('div');
      container.setAttribute('id', this.id + '-' + 'autocomplete-list');
      container.setAttribute('class', 'autocomplete-items');
      this.parentNode.appendChild(container);
      for (counter = 0; counter < jobListing.length; counter++) {
        if (
          jobListing[counter].substr(0, val.length).toUpperCase() ===
          val.toUpperCase() || jobListing[counter].toUpperCase().indexOf(val.toUpperCase()) > -1
        ) {
          element = document.createElement('div');
          element.innerHTML += jobListing[counter];
          element.innerHTML +=
            "<input type='hidden' value='" + jobListing[counter] + "'>";
          element.addEventListener('click', function (e) {
            jobInput.value = this.getElementsByTagName('input')[0].value;
            closeAllLists();
            document.getElementById('listingForm').submit();
          });
          container.appendChild(element);
        }
      }
    });

    jobInput.addEventListener('click', function (e) {
      var container,
        element,
        counter,
        val = this.value;

      var node = this.parentNode;

      closeAllLists();

      if (!val || val.length <= 1) {
        displayList(container, element, counter, node);
      }
    });

    // Keydown event
    jobInput.addEventListener('keydown', function (e) {
      var x = document.getElementById(this.id + '-' + 'autocomplete-list');
      if (x) x = x.getElementsByTagName('div');
      if (e.key === 'ArrowDown') {
        addActive(x);
        currentFocus++;
      } else if (e.key === 'ArrowUp') {
        addActive(x);
        currentFocus--;
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (currentFocus > -1) {
          if (x)
            document.getElementsByClassName('autocomplete-active')[0].click();
        }
        document.getElementById('listingForm').submit();
      } else if (e.key === 'Backspace') {
        var val = document.getElementById('jobSearch').value;

        closeAllLists();

        if (val.length <= 1) {
          document.getElementById('jobSearch').click();
        }
      }
    });

    function removeActive(x) {
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove('autocomplete-active');
      }
    }

    function addActive(x) {
      if (!x) return false;
      removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = x.length - 1;
      x[currentFocus].classList.add('autocomplete-active');
    }

    function closeAllLists(element) {
      var x = document.getElementsByClassName('autocomplete-items');
      for (var i = 0; i < x.length; i++) {
        if (element != x[i] && element != jobInput) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }

    function displayList(container, element, counter, node) {
      currentFocus = -1;
      container = document.createElement('div');
      container.setAttribute('id', this.id + '-' + 'autocomplete-list');
      container.setAttribute('class', 'autocomplete-items');
      node.appendChild(container);
      for (counter = 0; counter < 5; counter++) {
        element = document.createElement('div');
        element.innerHTML += jobListing[counter];
        element.innerHTML +=
          "<input type='hidden' value='" + jobListing[counter] + "'>";
        element.addEventListener('click', function (e) {
          jobInput.value = this.getElementsByTagName('input')[0].value;
          closeAllLists();
        });
        container.appendChild(element);
      }
    }

    document.addEventListener('click', function (e) {
      closeAllLists(e.target);
    });
  },
});
